import React, {useRef, useState} from 'react';
import {useTranslation} from "react-i18next";
import {useHistory} from "react-router";

import {getMaterialUrl} from "../modules/url";


import PolygonWithEffects from "./PolygonWithEffects";


type FramedImageProps = {
  index: number;
  frames?: { coordinates: [number, number][], href: string, imgRefs: number[], has_geom_frame: boolean }[];
  id: number;
  isActiveSlide: boolean;
  onClose: () => void;
};

const FramedImage = ({ index, frames, id, isActiveSlide, onClose}: FramedImageProps) => {
  const {t} = useTranslation();
  const history = useHistory();
  const imgRef = useRef<HTMLImageElement>(null);

  const [naturalSize, setNaturalSize] = useState({width: 1, height: 1});

  const handleImageLoad = (event: React.SyntheticEvent<HTMLImageElement>) => {
    const img = event.currentTarget;
    setNaturalSize({width: img.naturalWidth, height: img.naturalHeight});
  };
  const imgSrc =`${getMaterialUrl()}/img/spreads/ddz_spread_${id}.jpg`;
  const notFoundImage = imgSrc?.startsWith("data:image/svg+xml");

  return (
    <div className="flex justify-center items-center relative">
      <img
        ref={imgRef}
        src={imgSrc}
        alt={`Diese Karte ist noch nicht verfügbar und wird in Zukunft bereitgestellt. Slide ${index + 1}`}
        className={`object-contain ${notFoundImage ? 'max-h-[50vh]' : 'max-h-[90vh]'} w-full `}
        onLoad={handleImageLoad}
      />

      <div className="absolute top-0 left-0 w-full h-full">
        {frames?.map((frame, i) => {
          if (!frame || !frame.coordinates?.length) return null;

          const normalizedCoordinates = frame.coordinates.map(([x, y]) => ({x, y}));

          return (
            <React.Fragment key={i}>
              <svg
                key={i}
                className="absolute top-0 left-0 w-full h-full pointer-events-none"
                viewBox={`0 0 ${naturalSize.width} ${naturalSize.height}`}
                style={{
                  transformOrigin: 'top left',
                }}
              >
                { frame.has_geom_frame &&
                  <g
                    onClick={() =>{
                      // window.location.replace(BASE_URL.href + `globus?kmz=${frame.imgRefs[i]}`)
                      history.replace(`globus?kmz=${frame.imgRefs[i]}`);
                      onClose();
                    }
                    }
                  >
                    <PolygonWithEffects normalizedCoordinates={normalizedCoordinates} isActiveSlide={isActiveSlide} isMissingImage={false} />
                  </g>
                }
              </svg>
            </React.Fragment>
          );
        })}
        {notFoundImage && (
          <h1 className="p-2 text-center italic text-gray-400">{t('atlas:mix.firstDownloadMap')}</h1>
        )}

      </div>


    </div>
  );
};

export default FramedImage;
